module.exports = __webpack_public_path__ + "media/images/product/p_h-f7fc93655cf9f76396ad024b819a8ae2.png";